var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "subscription-form-container",
        title: _vm.title,
        "hide-footer": "",
        centered: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "form",
        {
          attrs: { "data-vv-scope": "subscription-form" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.save($event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "w-100 pl-5 pr-5 mb-32" },
            [
              _c(
                "b-alert",
                {
                  staticClass: "text-sm",
                  attrs: { variant: "info", show: "" }
                },
                [
                  _c("h4", { staticClass: "alert-heading" }, [
                    _vm._v(" Información ")
                  ]),
                  _c("div", { staticClass: "alert-body pl-8" }, [
                    _c("ul", { staticClass: "infoList" }, [
                      _c("li", [
                        _vm._v("Los campos con (*) son obligatorios.")
                      ]),
                      _c("li", [
                        _vm._v(
                          ' si deseas agregar una suscripción sin limite de tiempo, el campo "Hasta" debe estar en blanco. '
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "Si el usuario no cuenta permisos asociados, junto con la suscripción obtendrá permisos de lectura."
                        )
                      ])
                    ])
                  ])
                ]
              ),
              !_vm.isSelfSubscription
                ? _c(
                    "b-form-group",
                    { attrs: { label: "(*) Usuario", "label-for": "user" } },
                    [
                      _c("ListUser", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          id: "user",
                          name: "user",
                          "data-cy": "user",
                          label: "",
                          placeholder: "Seleccione un usuario...",
                          danger: _vm.errors.has("subscription-form.user"),
                          "danger-text": _vm.errors.first(
                            "subscription-form.user"
                          )
                        },
                        model: {
                          value: _vm.selectedUserId,
                          callback: function($$v) {
                            _vm.selectedUserId = $$v
                          },
                          expression: "selectedUserId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-form-group",
                { attrs: { label: "(*) Desde", "label-for": "fromDate" } },
                [
                  _c("b-form-datepicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "form-control bg-white",
                    attrs: {
                      id: "fromDate",
                      name: "fromDate",
                      "data-cy": "calendar-from-date",
                      "data-vv-as": "Desde",
                      placeholder: "Selecciona una fecha",
                      locale: "es",
                      min: _vm.minDate,
                      state:
                        !_vm.errors.has("subscription-form.fromDate") &&
                        _vm.fromDate !== null,
                      "label-help":
                        "Puede usar las flechas del teclado y espacio"
                    },
                    model: {
                      value: _vm.fromDate,
                      callback: function($$v) {
                        _vm.fromDate = $$v
                      },
                      expression: "fromDate"
                    }
                  }),
                  _c("FormError", {
                    attrs: {
                      attributeName: "subscription-form.fromDate",
                      errorsForm: _vm.errors
                    }
                  })
                ],
                1
              ),
              _c(
                "b-form-group",
                { attrs: { label: "Hasta", "label-for": "toDate" } },
                [
                  _c("b-form-datepicker", {
                    staticClass: "form-control bg-white",
                    attrs: {
                      id: "toDate",
                      name: "toDate",
                      "data-cy": "calendar-to-date",
                      "data-vv-as": "Hasta",
                      placeholder: "Selecciona una fecha",
                      locale: "es",
                      min: _vm.fromDate || _vm.minDate,
                      state: !_vm.errors.has("subscription-form.toDate"),
                      "label-help":
                        "Puede usar las flechas del teclado y espacio"
                    },
                    model: {
                      value: _vm.toDate,
                      callback: function($$v) {
                        _vm.toDate = $$v
                      },
                      expression: "toDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("vs-divider", { staticClass: "pt-32" }),
          _c(
            "div",
            { staticClass: "d-flex justify-end" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "ml-3",
                  attrs: {
                    color: "primary",
                    type: "border",
                    "data-cy": "save"
                  },
                  on: { click: _vm.save }
                },
                [
                  _vm._v(" Suscribir "),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "spinner-border spinner-border-sm text-white"
                  })
                ]
              ),
              _c(
                "vs-button",
                {
                  staticClass: "ml-3",
                  attrs: { color: "danger", type: "border" },
                  on: { click: [_vm.closeModal, _vm.clearForm] }
                },
                [
                  _vm._v(" Cancelar "),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "spinner-border spinner-border-sm text-white"
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }